import React, { memo } from 'react';
import PropTypes from 'prop-types';

// Components
import { Modal } from '@beef/ui-kit';
import { Content } from './components/Content';
import { ContentActions } from './components/ContentActions';

const CommonModal = memo(({
  onClose,
  isOpen,
  size = 'm',
  onConfirm,
  onAdditionalConfirm,
  data,
  isCloseButtonVisible = true,
  isLoading,
}) => (
  <Modal
    onClose={onClose}
    isOpen={isOpen}
    isLoading={isLoading}
    size={size}
    actionBar={!isLoading
      ? <ContentActions onConfirm={onConfirm} onAdditionalConfirm={onAdditionalConfirm} data={data} />
      : null}
    isCloseButtonVisible={isCloseButtonVisible}
  >
    <Content data={data} />
  </Modal>
));

CommonModal.propTypes = {
  onConfirm: PropTypes.func,
  onAdditionalConfirm: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  isCloseButtonVisible: PropTypes.func,
  size: PropTypes.string,
  data: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    imageUrl: PropTypes.string,
    buttonGroup: PropTypes.array,
  }),
};

export { CommonModal };
